

























import Vue, { PropType } from 'vue';
import SearchBannerFormItem from '../SearchBannerFormItem.vue';
import CitySelect from '../../../../../../../SearchBar/view/vue/components/CitySelect.vue';
import { ICity } from '../../../../../../../SearchBar/view/vue/domain/City';
import type { DrawerConfig } from '../types';

export default Vue.extend({
  name: 'SearchBannerCityDropdown',
  components: {
    SearchBannerFormItem,
    CitySelect,
  },
  props: {
    storeNamespace: {
      type: String,
      required: true,
    },
    isDesktop: {
      type: Boolean,
      required: true,
    },
    id: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      default: '',
    },
    drawerConfig: {
      type: Object as PropType<DrawerConfig>,
      required: true,
    },
    active: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      selectedCityLabel: undefined as string | undefined,
      citySelectLabels: {
        title: undefined as string | undefined,
      },
    };
  },
  computed: {
    displayValue(): string | undefined {
      if (this.isDesktop) {
        return this.$store.getters[`${this.storeNamespace}/cityDisplayValueDesktop`];
      }
      return this.$store.getters[`${this.storeNamespace}/cityDisplayValueMobile`];
    },
    isActive: {
      get(): boolean {
        return this.active;
      },
      set(value: boolean) {
        this.$emit('update:active', value);
      },
    },
  },
  methods: {
    async handleCitySelect(city: ICity) {
      this.selectedCityLabel = city.location;
      this.citySelectLabels = {
        title: this.selectedCityLabel,
      };

      await this.$store.dispatch(`${this.storeNamespace}/updateCity`, city);
      this.$emit('city-selected');
      this.isActive = false;
    },
    handleCityLoading(isLoading: boolean) {
      this.loading = isLoading;
    },
  },
});
